import { useMemo, useState } from "react";

import ProjectToolbar from "./ProjectToolbar";
import ProjectRow from "./ProjectRow";
import ProjectPagination from "./ProjectPagination";

const ITEMS_PER_PAGE = 10;

const ProjectTable = ({
  projects = [],
  onProjectClick,
  onFullscreen,
  onEditProject,
  isFullscreen,
}) => {
  const [search, setSearch] = useState("");

  const [filters, setFilters] = useState({
    status: "",
    priority: "",
    executionMode: "",
  });

  const [currentPage, setCurrentPage] = useState(1);

  // ============================================================
  // FILTER PROJECTS
  // ============================================================

  const filteredProjects = useMemo(() => {
    return projects.filter((project) => {
      const projectName =
        project?.project_name || "";

      const projectCode =
        project?.project_code || "";

      const searchValue =
        search.toLowerCase();

      const matchesSearch =
        projectName
          .toLowerCase()
          .includes(searchValue) ||
        projectCode
          .toLowerCase()
          .includes(searchValue);

      const matchesStatus =
        !filters.status ||
        project.status === filters.status;

      const matchesPriority =
        !filters.priority ||
        project.priority === filters.priority;

      const matchesExecution =
        !filters.executionMode ||
        project.execution_mode ===
          filters.executionMode;

      return (
        matchesSearch &&
        matchesStatus &&
        matchesPriority &&
        matchesExecution
      );
    });
  }, [projects, search, filters]);

  // ============================================================
  // PAGINATION
  // ============================================================

  const totalPages = Math.ceil(
    filteredProjects.length / ITEMS_PER_PAGE
  );

  const paginatedProjects =
    filteredProjects.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      currentPage * ITEMS_PER_PAGE
    );

  return (
    <div
      className={
        isFullscreen
          ? "fixed inset-0 z-50 overflow-auto bg-white"
          : "rounded-lg border bg-white"
      }
    >
      {/* ======================================================
          TOOLBAR
      ====================================================== */}

      <ProjectToolbar
        search={search}
        setSearch={setSearch}
        filters={filters}
        setFilters={setFilters}
        onFullscreen={onFullscreen}
      />

      {/* ======================================================
          TABLE
      ====================================================== */}

      <div className="overflow-x-auto">
        <table className="min-w-full">

          {/* HEADER */}

          <thead className="border-y bg-gray-50">
            <tr>

              <th className="px-5 py-4 text-left">
                Project
              </th>

              <th className="px-5 py-4 text-left">
                Type
              </th>

              <th className="px-5 py-4 text-left">
                Status
              </th>

              <th className="px-5 py-4 text-left">
                Priority
              </th>

              <th className="px-5 py-4 text-left">
                Execution
              </th>

              <th className="px-5 py-4 text-left">
                Start Date
              </th>

              <th className="px-5 py-4 text-center">
                Actions
              </th>

            </tr>
          </thead>

          {/* BODY */}

          <tbody>
            {paginatedProjects.length > 0 ? (
              paginatedProjects.map((project) => (
                <ProjectRow
                  key={

                    project?.uuid ||
                    project?.project_uuid ||
                    project?.project_code

                  }
                  project={project}
                  onClick={onProjectClick}
                  onEdit={onEditProject}
                />
              ))
            ) : (
              <tr>
                <td
                  colSpan={7}
                  className="px-5 py-10 text-center text-sm text-gray-500"
                >
                  No projects found.
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>

      {/* ======================================================
          PAGINATION
      ====================================================== */}

      <ProjectPagination
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default ProjectTable;